import { formatNumberWithThousandsSeparator } from '../calculator/_utilities'

const initializeChart = (config) => {
  Chart.pluginService.register({
    beforeDraw: function (chart) {
      if (chart.config.options.chartArea && chart.config.options.chartArea.backgroundColor) {
        const ctx = chart.chart.ctx
        const area = chart.chartArea
        ctx.save()
        ctx.fillStyle = chart.config.options.chartArea.backgroundColor
        ctx.fillRect(area.left, area.top, area.right - area.left, area.bottom - area.top)
        ctx.restore()
      }
    },
  })

  config.chart = new Chart(config.elements.chart, {
    type: 'bar',
    data: {
      labels: ['Year 0'],
      datasets: [
        {
          id: 'SCU',
          label: 'SCU',
          data: [],
          fill: false,
          borderColor: '#b3282d',
          backgroundColor: '#b3282d',
          pointRadius: 5,
          pointHoverRadius: 5,
          lineTension: 0,
        },
        {
          id: 'Banks',
          label: 'Competitor Rate',
          data: [],
          fill: false,
          borderColor: '#44273a',
          backgroundColor: '#44273a',
          pointRadius: 5,
          pointHoverRadius: 5,
          lineTension: 0,
        },
      ],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        position: 'top',
      },
      tooltips: {
        position: 'nearest',
        displayColors: false,
        bodyFontColor: '#fff',
        callbacks: {
          title: function () {
            return null
          },
          label: function (tooltipItem) {
            return formatNumberWithThousandsSeparator(tooltipItem.yLabel)
          },
        },
      },
      chartArea: {
        backgroundColor: '#fff',
      },
    },
  })
}

// Function to update chart labels for years based on the investment length
const updateChartLabels = (config, investmentLength) => {
  const labels = []
  investmentLength++
  for (let i = 1; i < investmentLength; i++) {
    labels.push('Year ' + i)
  }
  config.chart.data.labels = labels
}

const updateChart = (config, currentValues, currentSavings, rates) => {
  const chartData = config.chart.data.datasets
  const ratesSCU = _.find(chartData, ['id', 'SCU'])
  const ratesBank = _.find(chartData, ['id', 'Banks'])
  currentSavings.scu.shift()
  currentSavings.banks.shift()

  config.chart.options.scales.yAxes[0].ticks.min = currentValues.initial_investment
  ratesSCU.label = 'SCU Rate - ' + rates.scu.toFixed(2) + '%'
  ratesSCU.data = currentSavings.scu
  ratesBank.label = 'Competitor Rate - ' + rates.banks.toFixed(2) + '%'
  ratesBank.data = currentSavings.banks
  config.chart.update()
}

export { initializeChart, updateChart, updateChartLabels }
